export default __webpack_public_path__ + "static/media/Banker.6823097b.svg";